module.exports = __webpack_public_path__ + "img/login-logo-light.a01914d5.svg";